import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { AlertSeverityEnum, ITYPERegimensRes,TYPERegimens, UseMutationsParams  } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

export const useFetchTypeRegimens = (params?: GetTypeRegimensParams , enabled = true) => {
    return useQuery({
      queryKey: ['type-regimenes', ...Object.values(params ?? {})],
      queryFn: async () => {
        return getTypeRegimens(params);
      },
      enabled,
    });
  };
  export const useGetTypeRegimen=(id:string)=>{
    return useQuery({
      queryKey: ['type-regimen',id],
      queryFn: async () => {
          return getTypeRegimen(id);
          }
      });
  }
  export const useCreateTypeRegimen=({
    navigate,
  
    enableRedirect = true,
    returnUrl,
  
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
  
    enableSuccessAlert = true,
    customSuccessMessage,
  }: UseMutationsParams) => {
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: createTypeRegimens,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['type-regimen'] });
  
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'tipo regimen creada correctamente',
            AlertSeverityEnum.success
          );
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
  
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
  export const useUpdateTypeRegimenes= ({
    navigate,
    enableRedirect = true,
    returnUrl,
    returnErrorUrl,
    enableErrorRedirect = false,
    customMessageErrorAlert,
    enableSuccessAlert = true,
    customSuccessMessage,
    onSuccess
  }: UseMutationsParams & { onSuccess?: () => void }) => { // Update this line
    const queryClient = useQueryClient();
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    const setAlert = useUiStore.getState().setAlert;
  
    return useMutation({
      mutationFn: updateTypeRegimens,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['type-regimen'] });
        enableRedirect && navigate && returnUrl && navigate(returnUrl);
  
        enableSuccessAlert &&
          setAlert &&
          setAlert(
            true,
            customSuccessMessage ?? 'Tipo regimen actualizado correctamente',
            AlertSeverityEnum.success
          );
  
        onSuccess && onSuccess(); // Add this line
      },
      onError: error => {
        enableErrorRedirect &&
          navigate &&
          returnUrl &&
          navigate(returnErrorUrl ?? (returnUrl || ''));
        handleAxiosError(error, customMessageErrorAlert);
      },
      onSettled: () => {
        setIsGlobalLoading(false);
      },
    });
  };
    //axios
    export type GetTypeRegimensParams ={
        page?: number;
        nombre?: string;
        page_size?: number;
    }
    export type CreateTypeRegimensParams= Omit<TYPERegimens,'id_tipo_regimen'>;
    export type UpdateTypeRegimensParams={
        id:number;
        data:CreateTypeRegimensParams;
    }
    export const getTypeRegimens = async (params?: GetTypeRegimensParams) => {
        const queryParams = getUrlParamsFetch({ ...params });
        return get <ITYPERegimensRes>(
        `${urlBackend}api/v1/tipo-regimen/?${queryParams}`,
        true
        );
    };
    export const getTypeRegimen = async (id:string) => {
        try{
            return await get <TYPERegimens>(
        `${urlBackend}api/v1/tipo-regimen/${id}`,
        true
        );
    }
    catch(error){
      return handleAxiosError(error);
    }
    };
    export const createTypeRegimens = async (data:CreateTypeRegimensParams) => {
        const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
        setIsGlobalLoading(true);
        return post<TYPERegimens>(`${urlBackend}api/v1/tipo-regimen/`, data, true);
    };

 export const updateTypeRegimens = async ({ id, data }: UpdateTypeRegimensParams) => {
    const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
    setIsGlobalLoading(true);
    return put<TYPERegimens>(`${urlBackend}api/v1/tipo-regimen/${id}/`, data, true);
        }
        